import React, { useCallback } from 'react'

import Image from 'next/image'
import { useRouter } from 'next/navigation'

import { SectionContainer } from 'Components/Blocks'
import { Button, Column, Row, Text } from 'Components/UI'

import { LANDING_CONTENT_PX } from 'Constants/Landing'

import { THANK_YOU_LINKS_CARDS } from './constants'
import { Container, ImageHolder } from './styles'

function ThankYouLinksSection() {
  const router = useRouter()

  const handleButtonClick = useCallback(
    (link: string) => {
      router.push(link)
    },
    [router],
  )

  return (
    <SectionContainer>
      <Row fullWidth justifyCenter px={LANDING_CONTENT_PX}>
        <Container
          flexDirection={['column', 'column', 'column', 'row']}
          gap={[9, 9, 9, 11]}
        >
          {THANK_YOU_LINKS_CARDS.map(item => (
            <Column fullHeight fullWidth gap={7} key={item.id} spaceBetween>
              <Column gap={7}>
                <ImageHolder>
                  <Image alt="" fill src={item.image} />
                </ImageHolder>

                <Column gap={5}>
                  <Text bold primary screen24>
                    {item.title}
                  </Text>

                  <Text primary screen18>
                    {item.description}
                  </Text>
                </Column>
              </Column>

              <Row>
                <Button
                  minWidth="128px"
                  onClick={() => handleButtonClick(item.link)}
                >
                  {item.buttonCaption}
                </Button>
              </Row>
            </Column>
          ))}
        </Container>
      </Row>
    </SectionContainer>
  )
}

export default ThankYouLinksSection
